import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetPrizeLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_PRIZE_LOTTERY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetPrizeLotteryAction(
                    {
                        prizes: [...data.data]
                    }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetPrizeLottery as SetGetPrizeLottery
}